import { Link } from 'react-router-dom';
import { rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  const col1 = rankingComics.filter((_, i) => i % 3 === 0);
  const col2 = rankingComics.filter((_, i) => i % 3 === 1);
  const col3 = rankingComics.filter((_, i) => i % 3 === 2);

  const getRankColor = (rank: number) => {
    if (rank <= 3) return 'bg-accent-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-8">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1 rounded-full mb-3">
            TOP 排行
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            人气排行榜
            <br />
            <span className="text-foreground-600 font-normal text-2xl md:text-3xl">最受欢迎的漫画都在这里</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[col1, col2, col3].map((col, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-5">
              {col.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="bg-background-50 rounded-xl p-4 md:p-5 group hover:bg-background-50/80 transition-colors"
                >
                  <div className="flex items-start gap-4 mb-3">
                    <div className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${getRankColor(comic.rank)}`}>
                      {comic.rank}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading text-lg text-foreground-900 font-bold group-hover:text-primary-600 transition-colors truncate">
                        {comic.title}
                      </h3>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="text-xs text-foreground-400">{comic.category}</span>
                        <span className="text-xs text-accent-500 font-medium">
                          <i className="ri-star-fill text-[10px] mr-0.5"></i>
                          {comic.rating}
                        </span>
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 pl-13">
                    {comic.description}
                  </p>
                  <div className="flex items-center gap-2 mt-3 pl-13">
                    {comic.tags.map((tag) => (
                      <span key={tag} className="text-xs text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}